import { Link } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center">
      <Seo
        title="Page Not Found | WHO — Warm Hand Off"
        description="The page you're looking for doesn't exist. Return to WHO to explore our warm-handoff platform."
        path="/404"
      />
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 w-full">
        <div className="max-w-2xl">
          <p className="eyebrow text-gold" data-testid="not-found-eyebrow">Error 404</p>
          <h1 className="mt-5 font-display font-black text-navy tracking-tight leading-[1.02] text-5xl sm:text-6xl lg:text-7xl">
            This connection<br />didn&apos;t reach.
          </h1>
          <p className="mt-6 text-lg lg:text-xl text-slateSoft leading-relaxed max-w-xl">
            The page you&apos;re looking for doesn&apos;t exist — but we make sure every real connection does.
            Let&apos;s get you back on the path.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/"
              data-testid="not-found-home-btn"
              className="inline-flex items-center gap-2 bg-gold hover:bg-gold-deep text-navy font-semibold px-6 py-3.5 rounded-md transition-colors"
            >
              <Home className="w-4 h-4" /> Return home
            </Link>
            <Link
              to="/contact"
              data-testid="not-found-contact-btn"
              className="inline-flex items-center gap-2 border border-navy text-navy hover:bg-navy hover:text-cream font-semibold px-6 py-3.5 rounded-md transition-colors"
            >
              Contact WHO <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
